import { render, staticRenderFns } from "./showAll.vue?vue&type=template&id=2f92ab6e&scoped=true&"
import script from "./showAll.vue?vue&type=script&lang=js&"
export * from "./showAll.vue?vue&type=script&lang=js&"
import style0 from "./showAll.vue?vue&type=style&index=0&id=2f92ab6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f92ab6e",
  null
  
)

export default component.exports